import { FunctionComponent, Fragment } from 'preact';

import { TouchPanel } from '../TouchPanel/TouchPanel';

interface DoubleTapProps {
  onTap: (e: MouseEvent) => void;
  onLeftDoubleTap: () => void;
  onRightDoubleTap: () => void;
  collapsed?: boolean;
}

export const DoubleTap: FunctionComponent<DoubleTapProps> = ({
  onTap,
  onLeftDoubleTap,
  onRightDoubleTap,
  collapsed,
}) => {
  return (
    <Fragment>
      <TouchPanel
        align="left"
        onTap={onTap}
        onDoubleTap={onLeftDoubleTap}
        collapsed={collapsed}
      />
      <TouchPanel
        align="right"
        onTap={onTap}
        onDoubleTap={onRightDoubleTap}
        collapsed={collapsed}
      />
    </Fragment>
  );
};
